import { useCallback, useEffect, useMemo, useState } from 'react';
import { dotHocService } from '../services/dot_hoc/dotHocService';

export function useHeDaoTao() {
    const [items,setItems]=useState<{ID_he:number;Ten_he:string;NghienCuuSinh:boolean}[]>([]);
    const [loading,setLoading]=useState(true),[error,setError]=useState('');
    useEffect(()=>{let active=true;
        dotHocService.getHeDaoTao().then(data=>{if(active)setItems(data);}).catch(()=>{if(active)setError('Không tải được danh mục hệ đào tạo. Vui lòng thử lại.');}).finally(()=>{if(active)setLoading(false);});
        return()=>{active=false;};
    },[]);
    const names=useMemo(()=>new Map(items.map(item=>[item.ID_he,item.Ten_he])),[items]);
    const label=useCallback((id:number)=>names.get(id)||(id?`Hệ ${id} (chưa có trong danh mục SDH)`:'Chưa xác định'),[names]);
    return{items,loading,error,label};
}
